<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">设置关于我们</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      设置关于我们信息
      <small>关于我们...</small>
    </h1>
    <!-- end page-header -->
    <panel title="关于我们" :noButton="true">
      <div slot="heading-btn">
        <button class="btn btn-theme btn-sm" type="button" @click="fn_save">
          <i class="fa fa-save"></i> 保 存
        </button>
      </div>
      <div class="editor-wrapper">
        <div :id="editorId"></div>
      </div>
    </panel>
  </div>
</template>
<script>
import Editor from "wangeditor";
import "wangeditor/release/wangEditor.css";
import { getToken } from "@/libs/util";
import config from "@/config";
import { uploadbase64 } from "@/api/upload";
import { getEnumByCode, saveEnumData } from "@/api/config";
export default {
  data() {
    return {
      uploadhost: config.baseUrl.pro + "/upload/uploadfile",
      logourl: config.baseUrl.imageurl,
      aboutus: ""
    };
  },
  computed: {
    editorId() {
      return `editor${this._uid}`;
    }
  },
  mounted() {
    this.iniRichText();
    getEnumByCode("aboutus")
      .then(res => {
        let data = res.data;
        this.aboutus = data["aboutus"].remarks;
        this.editor.txt.html(this.aboutus);
      })
      .catch(error => {
        this.$Message.error(error);
      });
  },
  methods: {
    iniRichText() {
      // console.log(this.Field.columname, this.FieldListData);
      this.editor = new Editor(`#${this.editorId}`);
      this.editor.customConfig.onchange = html => {
        let text = this.editor.txt.text();
        if (this.cache) localStorage.editorCache = html;
        this.$emit("input", this.valueType === "html" ? html : text);
        this.$emit("on-change", html, text);
      };
      this.editor.customConfig.onchangeTimeout = this.changeInterval;
      // create这个方法一定要在所有配置项之后调用
      this.editor.customConfig.zIndex = 1; // 设置菜单的垂直高度

      this.editor.customConfig.uploadImgServer = this.uploadhost;
      //  "http://47.106.198.122/api/CanteenAdmin/CanteenManagement/UploadImage"; // 配置服务器端地址
      this.editor.customConfig.uploadImgHeaders = {
        Authorization: "Bearer" + getToken()
      }; // 自定义 header
      this.editor.customConfig.uploadFileName = "filename"; // 后端接受上传文件的参数名
      this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024; // 将图片大小限制为 2M
      this.editor.customConfig.uploadImgMaxLength = 6; // 限制一次最多上传 3 张图片
      this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
      // this.editor.customConfig.uploadParams = {formFile:'2'};
      // 配置菜单
      this.editor.customConfig.menus = [
        "head",
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "video", // 插入视频
        "code", // 插入代码
        "undo", // 撤销
        "redo" // 重复
      ];

      this.editor.customConfig.uploadImgHooks = {
        fail: (xhr, editor, result) => {
          // 插入图片失败回调
        },
        success: (xhr, editor, result) => {
          // 图片上传成功回调
          //
          let imgUrl = result.data;
          insertImg(imgUrl);
        },
        timeout: (xhr, editor) => {
          // 网络超时的回调
        },
        error: (xhr, editor) => {
          console.log(editor);
          // 图片上传错误的回调
        },
        customInsert: (insertImg, result, editor) => {
          // 图片上传成功,插入图片的回调

          // if(result.code == 200){
          var url = this.logourl + result.data;
          //   console.log(url);
          insertImg(url); //将内容插入到富文本中
          // console.log(insertImg(url)+"DFDF")
          // console.log(data+"dsfd")
          // }
        }
      };

      this.editor.customConfig.onchange = html => {
        this.info_ = html; // 绑定当前逐渐地值
        this.$emit("change", this.info_); // 将内容同步到父组件中
        this.aboutus = html;
      };

      // 创建富文本编辑器

      this.editor.create();
      // 如果本地有存储加载本地存储内容
    },
    fn_save() {
      saveEnumData({
        code: "aboutus",
        remarks: this.aboutus,
        value: ""
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
  }
};
</script>